/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MultipleChoice/view.blocks to change it.
import Options from './Options/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function MultipleChoice({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/MultipleChoice"
  
}) {
  return (<React.Fragment
>
<Options
  viewPath={`${viewPath}/Options`}
/>
{children}
</React.Fragment>)
}